export default __webpack_public_path__ + "static/media/historical-picture.64f6da81.jpg";